import React, { useEffect, useState } from 'react';
import { Card, CardBody, CardHeader, CustomInput, Input } from 'reactstrap';
import {
  getBodyType,
  getBraSize,
  getHeightData,
  getUserUsuallyWears,
  removeEmptyProperties,
} from '../../../helpers/utils';
import { ButtonWithLoadingIcon } from '../../common/ButtonWithLoadingIcon';
import { CustomCardHeader } from '../../common/custom-card-header/CustomCardHeader';
import { AboutMeEdit } from './about-me-edit/AboutMeEdit';
import { AboutMePreferences } from './about-me-preferences/AboutMePreferences';
import './aboutme.scss';

const ABOUT_ME_UPDATING_PARTS = {
  about_me_pref: 'about_me_pref',
  about_me_edit: 'about_me_edit',
};

export const AboutMe = ({
  updatingParts,
  profileData,
  braSize,
  heightData,
  bodyTypes,
  usuallyWearsData,
  handleDataChange,
  isSM,
}) => {
  const [isEditingMode, setIsEditingMode] = useState(false);

  // about me
  const aboutMe = {
    username: profileData?.username ?? '',
    usually_wears: profileData?.usually_wears
      ? `${profileData?.usually_wears?.size}, ${profileData.usually_wears?.ussize}, ${profileData.usually_wears?.denim}`
      : '',
    body_type: profileData?.body_type ?? '',
    bra_size: profileData?.bra_size
      ? `${profileData?.bra_size?.band}${profileData?.bra_size?.cup}`
      : '',
    age: profileData?.age ?? '',
    height: profileData?.height
      ? `${profileData.height?.feet}′ ${profileData.height?.inch}″`
      : '',
    weight: profileData?.weight ?? '',
    gender: profileData?.gender ?? '',
  };

  const aboutMePref = {
    username: profileData?.username ?? '',
    usually_wears: profileData?.usually_wears
      ? `${getUserUsuallyWears(
          usuallyWearsData,
          profileData.usually_wears?.size
        )}, ${getUserUsuallyWears(
          usuallyWearsData,
          profileData.usually_wears?.ussize
        )}, ${getUserUsuallyWears(
          usuallyWearsData,
          profileData.usually_wears?.denim
        )}`
      : '',
    body_type: profileData?.body_type
      ? getBodyType(bodyTypes, profileData.body_type)
      : '',
    bra_size: profileData?.bra_size
      ? `${getBraSize(braSize, profileData?.bra_size?.band)}${getBraSize(
          braSize,
          profileData?.bra_size?.cup
        )}`
      : '',
    age: profileData?.age ?? '',
    height: profileData?.height
      ? `${getHeightData(
          heightData,
          profileData.height?.feet
        )}′ ${getHeightData(heightData, profileData.height?.inch)}″`
      : '',
    weight: profileData?.weight ?? '',
    gender: profileData?.gender ?? '',
  };

  // preferences
  let review_display_preferences =
    profileData?.review_display_preferences ?? null;
  if (!review_display_preferences) review_display_preferences = {};

  const preferences = [
    {
      key: 'profile_photo',
      label: 'Profile Picture',
      isChecked: !!review_display_preferences.profile_photo,
    },
    {
      key: 'username',
      label: 'Username',
      value: aboutMePref.username,
      isChecked: !!review_display_preferences.username,
    },
    {
      key: 'usually_wears',
      label: 'Usually Wears',
      value: aboutMePref.usually_wears,
      isChecked: !!review_display_preferences.usually_wears,
    },
    {
      key: 'body_shape',
      label: 'Body Type',
      value: aboutMePref.body_type,
      isChecked: !!review_display_preferences.body_shape,
    },
    {
      key: 'bra_size',
      label: 'Bra Size',
      value: aboutMePref.bra_size,
      isChecked: !!review_display_preferences.bra_size,
    },
    {
      key: 'age',
      label: 'Age',
      value: aboutMePref.age,
      isChecked: !!review_display_preferences.age,
    },

    {
      key: 'height',
      label: 'Height',
      value: aboutMePref.height,
      isChecked: !!review_display_preferences.height,
    },
    {
      key: 'weight',
      label: 'Weight',
      value: aboutMePref.weight,
      isChecked: !!review_display_preferences.weight,
    },
    // {
    //   key: 'gender',
    //   label: 'Gender',
    //   value: aboutMePref.gender,
    //   isChecked: !!review_display_preferences.gender,
    // },
  ];

  // handlers
  const handlePreferenceSubmit = (newValues) => {
    const newPrefs = {
      review_display_preferences: newValues.reduce((container, preference) => {
        container[preference.key] = preference.isChecked;
        return container;
      }, {}),
    };
    console.log('he', newValues, newPrefs);
    handleDataChange(ABOUT_ME_UPDATING_PARTS.about_me_pref, newPrefs);
  };

  const handleEditSubmit = (newValues) => {
    removeEmptyProperties(newValues);
    handleDataChange(ABOUT_ME_UPDATING_PARTS.about_me_edit, newValues, () => {
      setIsEditingMode(false);
    });
  };

  return (
    <Card
      className='no-shadow profile-about-me-wrapper'
      style={{
        border: `1px solid #2E2B2B`,
        backgroundColor: 'transparent',
        marginRight: isSM ? 12 : 0,
        marginLeft: isSM ? 12 : 0,
      }}
    >
      <CustomCardHeader
        title='about me'
        actionBtnLabel={isEditingMode ? 'Close' : 'Edit'}
        handleActionBtnClick={(e) => {
          setIsEditingMode(!isEditingMode);
        }}
      />
      <CardBody>
        {isEditingMode ? (
          <AboutMeEdit
            isUpdating={updatingParts[ABOUT_ME_UPDATING_PARTS.about_me_edit]}
            aboutMeData={aboutMe}
            usuallyWearsData={usuallyWearsData}
            selectedUsuallyWears={profileData?.usually_wears ?? null}
            selectedBraSize={profileData?.bra_size ?? null}
            selectedHeight={profileData?.height ?? null}
            onSubmit={handleEditSubmit}
          />
        ) : (
          <AboutMePreferences
            isUpdating={updatingParts[ABOUT_ME_UPDATING_PARTS.about_me_pref]}
            preferences={preferences}
            selectedUsuallyWears={profileData?.usually_wears ?? null}
            onSubmit={handlePreferenceSubmit}
          />
        )}
      </CardBody>
    </Card>
  );
};
